import { Dispatch } from '../components/architecture/frontend/index'

import { gql } from '@apollo/client';
import { merge } from 'rxjs'
import { map, filter, withLatestFrom } from 'rxjs/operators'

import _ from 'lodash'
import bufferObject from './bufferObject'

bufferObject('locations')

const fragment = `
  fragment LocationData on Location {
    id
    name
    type
    code
    attention
    phone
    email
    emailCC
    address
    city
    state
    zip
    isActive
  }
  `

const MUTATE_UPSERT_LOCATIONS = gql`
  mutation upsertLocations(
      $locations: [LocationInput]
    ){
      upsertLocations(
        locations: $locations
      ) {
        ...LocationData
      }
    }
    ${fragment}
`;

const GET_LOCATIONS = gql`
  query locations {
    locations {
      ...LocationData
    }
  }
  ${fragment}
`;

Dispatch.getState('user.email')
  .pipe(
  )
  .subscribe(e => {
    if (_.isNil(e)) {
      Dispatch.nextAction('__.buffer.setRaw.locations', null)
    }
    else {
      Dispatch.nextAction('__.buffer.setLoading.locations')
      Dispatch.nextAction('Request.locations', { type: 'query', query: GET_LOCATIONS, variables: { }, poll: process.env.REACT_APP_POLL_INTERVAL,  retry: process.env.REACT_APP_RETRY_INTERVAL })
    }
  })

merge(Dispatch.getAction('Response.locations'), Dispatch.getAction('Response.locations.save'))
  .pipe(
    filter(e => _.isNil(e.errors)),
    map(e => e.data.locations ?? e.data.upsertLocations)
  )
  .subscribe(e => Dispatch.nextAction('__.buffer.setRawAndClearBuffer.locations', e))

Dispatch.getAction('locations.save')
    .pipe(
      withLatestFrom(Dispatch.getState('locations.bufferData')),
      map(([details, buffer]) => buffer.map(data => ({
        id: data.id, 
        code: data.code, 
        name: data.name, 
        type: details.type, 
        attention: data.attention, 
        phone: data.phone, 
        email: data.email, 
        emailCC: data.emailCC,
        address: data.address,
        city: data.city,
        state: data.state,
        zip: data.zip, 
      })))
    )
    .subscribe(e => Dispatch.nextAction('Request.locations.save', { type: 'mutation', query: MUTATE_UPSERT_LOCATIONS, variables: { locations: e } }))